export interface UTMParams {
  source?: string;
  campaign?: string;
  medium?: string;
}

export const captureUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') {
    return {};
  }

  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    source: urlParams.get('utm_source') || undefined,
    campaign: urlParams.get('utm_campaign') || undefined,
    medium: urlParams.get('utm_medium') || undefined,
  };
};

export const getStoredUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const stored = localStorage.getItem('utm_params');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const storeUTMParams = (params: UTMParams): void => {
  if (typeof window === 'undefined') return;
  
  try {
    // Only store if we have at least one UTM parameter
    if (params.source || params.campaign || params.medium) {
      localStorage.setItem('utm_params', JSON.stringify(params));
    }
  } catch {
    // Silently fail if localStorage is not available
  }
};

// Initialize UTM tracking on page load
export const initUTMTracking = (): UTMParams => {
  const currentParams = captureUTMParams();
  storeUTMParams(currentParams);
  return { ...getStoredUTMParams(), ...currentParams };
};